import { ChangeDetectorRef, Component, Input } from "@angular/core";
import moment from "moment";
import { UserService } from "../../../domain/user-service";
import { Router } from "@angular/router";

@Component({
  selector: "clock",
  templateUrl: "./clock.component.html",
  styleUrls: ["./clock.component.scss"],
})
export class ClockComponent {
  time;
  date;

  @Input()
  currentChannel;

  @Input()
  userTimeZones;

  currentTimeWithZone;
  allTimezones;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
  ) {
    window.setInterval(this.assignDate.bind(this), 1000);
    this.assignDate();
  }

  assignDate() {
    this.time = this.getCurrentTime();
    this.date = this.getCurrentDate();
    this.changeDetectorRef.markForCheck();
  }

  getCurrentTime() {
    let currentTime = moment();
    if (
      this.router.url === "/channels" ||
      this.router.url.startsWith("/recording")
    ) {
      // show local time on all channels display
      currentTime = currentTime.tz(moment.tz.guess());
    }
    return currentTime.format(`HH:mm:ss Z`);
  }

  getCurrentDate() {
    const format = "ddd DD MMM YYYY";
    return this.currentTimeWithZone
      ? this.currentTimeWithZone.format(format).toUpperCase()
      : moment().format(format);
  }
}
